'use client'

import { useState } from 'react'
import s from './accordion.module.scss'
import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'

type AccordionProps = {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
}

export const AccordionV3: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className={s.accordion}>
      <button
        className={s.header}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="accordion-content"
      >
        <span className={s.title}>{title}</span>
        <span className={s.icon} aria-hidden>
          {open ? (
            <ArrowRight
              iconColor="#131313"
              svgProps={{
                style: {
                  transform: 'rotate(-90deg)',
                },
                width: 16,
                height: 16,
              }}
            />
          ) : (
            <ArrowRight
              iconColor="#131313"
              svgProps={{
                style: {
                  transform: 'rotate(90deg)',
                },
                width: 16,
                height: 16,
              }}
            />
          )}
        </span>
      </button>
      <div
        id="accordion-content"
        className={s.content}
        style={{ display: open ? 'block' : 'none' }}
      >
        {children}
      </div>
    </div>
  )
}
